<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="620px" scrollable>
      <v-card class="pl-4">
        <!-- close -->
        <v-toolbar elevation="0" class="title">
          <span class="textType--text pl-2">{{
            $t('message.pages.userPlan.billingDateTitle')
          }}</span>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- steps -->
        <v-card-text class="mt-2 pr-10 pl-4 pb-6" style="height: 400px">
          <v-row no-gutters justify="center" align="center">
            <v-col cols="12">
              <v-card
                width="100%"
                class="elevation-0 px-6"
                color="newBackground"
              >
                <v-card height="79px" width="100%" color="newBackground" flat>
                  <v-row
                    no-gutters
                    justify="center"
                    align="center"
                    class="fill-height"
                  >
                    <v-col cols="7">
                      <span class="billingDateText textType--text">{{
                        $t('message.pages.userPlan.monthDay')
                      }}</span>
                    </v-col>
                    <v-col cols="5">
                      <v-select-legacy
                        v-model="selectedNewDate"
                        :style="
                          $vuetify.theme.dark
                            ? ''
                            : 'background-color: #fff !important'
                        "
                        :label="$t('message.pages.userPlan.chooseDate')"
                        :items="possibleDates"
                        outlined
                        hide-details
                        dense
                      ></v-select-legacy>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-4">
              <v-card
                width="100%"
                class="elevation-0 px-6 py-4"
                color="newBackground"
              >
                <v-card width="100%" color="newBackground" flat>
                  <v-row
                    no-gutters
                    justify="center"
                    align="center"
                    class="fill-height"
                  >
                    <v-col
                      cols="12"
                      class="d-flex flex-row align-center justify-space-between"
                    >
                      <span class="firstText primary--text">{{
                        $t('message.pages.userPlan.today')
                      }}</span>
                      <span class="firstText textType2--text">{{
                        $t('message.pages.userPlan.nextPayment')
                      }}</span>
                    </v-col>
                    <v-col cols="12" class="my-2" style="position: relative">
                      <div class="lineDiv" style="position: absolute"></div>
                      <div
                        style="position: absolute"
                        class="circle firstCircle"
                      ></div>
                      <div
                        style="position: absolute"
                        class="circle secondCircle"
                      ></div>
                      <div
                        style="position: absolute"
                        class="circle thirdCircle"
                      ></div>
                    </v-col>
                    <v-col
                      cols="12"
                      class="d-flex flex-row align-center justify-space-between"
                    >
                      <span class="firstText primary--text">
                        {{ getCurrentDate() }}
                      </span>
                      <span class="secondText pr-2">
                        {{ getNextPaymentDate() }}
                      </span>
                      <span class="thirdText">
                        {{ getNextDayMonth(selectedNewDate) }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <v-card
                width="100%"
                class="elevation-0 px-6"
                color="newBackground"
              >
                <v-card width="100%" color="newBackground" flat>
                  <v-row
                    no-gutters
                    justify="center"
                    align="center"
                    class="fill-height"
                  >
                    <v-col cols="12" class="my-4">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <span class="billingDateDescription textType2--text">
                            {{ $t('message.pages.userPlan.modalText1') }}
                            {{ selectedNewDate.toString().padStart(2, '0') }}
                            {{ $t('message.pages.userPlan.modalText2') }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-4" v-if="defaultSource">
              <v-card
                width="100%"
                class="elevation-0 px-6"
                color="newBackground"
              >
                <v-card class="py-6" width="100%" color="newBackground" flat>
                  <v-row
                    no-gutters
                    justify="center"
                    align="center"
                    class="fill-height"
                  >
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-row
                            no-gutters
                            justify="space-between"
                            align="center"
                          >
                            <span class="billingDateText textType--text">
                              {{ $t('message.pages.userPlan.paymentForm') }}
                            </span>
                            <span>
                              <v-row no-gutters>
                                <template
                                  v-if="defaultSource.type === 'boleto'"
                                >
                                  <v-card
                                    style="padding-left: 2px"
                                    outlined
                                    width="35"
                                    height="24"
                                    class="rounded card-image d-flex align-center justify-center"
                                  >
                                    <v-img
                                      src="@/assets/boletoIcon.svg"
                                      max-width="24"
                                    />
                                  </v-card>
                                  <span class="pl-2">
                                    {{ $t('message.pages.userPlan.ticket') }}
                                  </span>
                                </template>
                                <template v-else>
                                  <img
                                    v-if="defaultSource.brand"
                                    :src="
                                      cardsImages[
                                        `${defaultSource.brand.toLowerCase()}`
                                      ]
                                    "
                                    width="35"
                                    class="rounded card-image"
                                  />
                                  <span class="pl-2">
                                    {{
                                      capitalizeFirstLetter(
                                        defaultSource.brand
                                      )
                                    }}-{{ defaultSource.last4 }}
                                  </span>
                                </template>
                              </v-row>
                            </span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="errors.fetchError" class="ml-10 pt-2">
              <v-card flat height="30" class="mb-4">
                <span class="error--text text-body-2 align-text d-block">
                  {{ errors.shownErrMsg }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="18" v-bind="attrs" v-on="on">
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <v-container
                      class="text-body-2 pa-0"
                      style="max-width: 230px"
                    >
                      {{ errors.tooltipErrMsg }}
                    </v-container>
                  </v-tooltip>
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-4 pb-7">
          <v-row no-gutters justify="center" align="center">
            <v-btn
              color="primary"
              :disabled="
                loadings.update || !hasSelectedDay || noSchedulingAndSameDay
              "
              :loading="loadings.update"
              @click="handleUpdateDate"
            >
              {{ $t('message.pages.userPlan.finishBtn') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import planApi from '@/services/planApi'
import { mapState } from 'vuex'
import i18n from '@/translations/lang'

export default {
  name: 'BillingDate',
  data: () => ({
    open: false,
    selectedNewDate: 1,
    possibleDates: [],
    loadings: {
      update: false,
    },
    hasScheduledDate: 10,
    actualDate: 10,
    defaultSource: {},
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
    errors: {
      fetchError: false,
      shownErrMsg: i18n.t('message.errors.unexpectedError'),
      tooltipErrMsg: 'Error',
    },
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    hasSelectedDay() {
      return !!this.selectedNewDate
    },
    noSchedulingAndSameDay() {
      if (!this.hasScheduledDate) {
        return this.selectedNewDate === this.actualDate
      }
      return false
    },
  },
  watch: {},
  mounted() {
    this.$root.$on('openBillingDate', (defaultSource) => {
      this.defaultSource = defaultSource
      this.setUserDates()
      this.setPossibleDates()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openBillingDate')
  },
  methods: {
    handleFetchError(err) {
      this.errors.fetchError = true
      this.errors.tooltipErrMsg =
        err.msg ??
        err.response.data.errMsg ??
        err.response.data.message ??
        'Error'
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
    },
    setUserDates() {
      this.hasScheduledDate =
        this.userPlanInfo.schedule_update_due_date?.new_due_date.slice(-2) ??
        false
      this.actualDate =
        Number(
          new Date(
            this.userPlanInfo.subscription.billing_cycle_anchor * 1000
          ).getDate()
        ) ?? false
      if (this.hasScheduledDate) {
        this.selectedNewDate = Number(this.hasScheduledDate)
      } else {
        this.selectedNewDate = Number(this.actualDate)
      }
    },
    setPossibleDates() {
      const datesArray = []
      const daysLength = 27
      for (let i = 1; i <= daysLength; i++) {
        // Convert the number to a string and add leading zero if needed
        const dateStr = Number(i.toString().padStart(2, '0'))
        datesArray.push(dateStr)
      }
      this.possibleDates = datesArray
    },
    async handleUpdateDate() {
      try {
        const hasScheduledDate =
          this.userPlanInfo.schedule_update_due_date?.new_due_date
        const actualDate = new Date(
          this.userPlanInfo.subscription.billing_cycle_anchor * 1000
        ).getDate()
        const newSelectedDate = this.selectedNewDate
        this.loadings.update = true
        if (
          hasScheduledDate &&
          Number(actualDate) === Number(newSelectedDate)
        ) {
          await this.deleteSchedule(hasScheduledDate.slice(-2))
        } else {
          await this.changePaymentDay()
        }
        this.loadings.update = false
      } catch (e) {
        this.handleFetchError(e)
      }
    },
    async deleteSchedule(date) {
      try {
        await planApi.deleteBillingScheduling(date)
        this.$root.$emit('refreshUserPlan')
        this.handleClose()
      } catch (error) {
        console.error('error', error)
      }
    },
    async changePaymentDay() {
      this.loadings.update = true
      try {
        await planApi.updateSubscription({
          due_date: this.selectedNewDate,
        })
        this.$root.$emit('refreshUserPlan')
        this.handleClose()
      } catch (error) {
        this.handleFetchError(error)
        console.error('error', error)
      }
    },
    handleClose() {
      this.open = false
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    getCurrentDate() {
      const currentDate = new Date()
      const currentDay = currentDate.getDate()
      const currentMonth = currentDate.getMonth() + 1
      return `${currentDay.toString().padStart(2, '0')}/${currentMonth
        .toString()
        .padStart(2, '0')}`
    },
    getNextPaymentDate() {
      const nextPaymentDate = new Date(
        this.userPlanInfo.subscription.current_period_end * 1000
      )
      const nextPaymentDay = nextPaymentDate.getDate()
      const nextPaymentMonth = nextPaymentDate.getMonth() + 1
      return `${nextPaymentDay.toString().padStart(2, '0')}/${nextPaymentMonth
        .toString()
        .padStart(2, '0')}`
    },
    getNextDayMonth(selectedDay) {
      const currentDate = new Date()
      const currentDay = currentDate.getDate()
      const currentMonth = currentDate.getMonth()
      const currentYear = currentDate.getFullYear()

      // Check if the selected day is in the current month or next month
      const nextMonth = (currentMonth + 1) % 12
      const selectedMonth = selectedDay < currentDay ? nextMonth : currentMonth

      // Calculate the expected billing date
      const expectedDate = new Date(
        currentYear + (selectedMonth < currentMonth ? 1 : 0),
        selectedMonth,
        selectedDay
      )
      return `${expectedDate.getDate().toString().padStart(2, '0')}/${(
        expectedDate.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}`
    },
  },
}
</script>

<style>
.billingDateText {
  font-weight: 500;
  font-size: 16px;
}
.billingDateDescription {
  font-weight: 400;
  font-size: 14px;
}
.circle {
  height: 11px;
  width: 11px;
  border-radius: 50%;
  display: inline-block;
}
.firstCircle {
  background-color: #3f55ee;
  transform: translateY(-50%);
}
.secondCircle {
  background-color: #e6e8f8;
  right: 50%;
  transform: translateY(-50%);
}
.thirdCircle {
  background-color: #ffffff;
  border: 1px solid #a0acff;
  right: 0;
  transform: translateY(-50%);
}
.lineDiv {
  border: 0.5px solid #a0acff;
  width: 100% !important;
}
.firstText {
  font-size: 16px;
  font-weight: 500;
}
.secondText {
  color: #585d83;
  font-size: 14px;
  font-weight: 400;
  text-decoration-line: line-through;
}
.thirdText {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #373b54;
}
</style>
